import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import {store} from "@/store";
import VueGtag from "vue-gtag-next";

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(store);
app.use(VueGtag, {
  property: {
    id: process.env.VUE_APP_GTM_ID as string || "",
  }
});

router.beforeEach((to, from, next) => {
  if (to.params.deviceTag) {
    store.dispatch("payOptions/setDeviceTag", to.params.deviceTag);
  }
  if (to.query.paymentOption) {
    store.dispatch("payOptions/setPaymentOption", to.query.paymentOption);
  }
  if (to.query.country) {
    store.dispatch("payOptions/setCountry", to.query.country);
  }
  if (to.query.selectedInstallment) {
    store.dispatch("payOptions/setSelectedInstallment", to.query.selectedInstallment);
  }
  if (to.query.currencySymbol) {
    store.dispatch("payOptions/setCurrencySymbol", to.query.currencySymbol);
  }
  if (to.query.phoneNumber) {
    store.dispatch("payOptions/setPhoneNumber", to.query.phoneNumber);
  }
  next();
});

app.mount("#app");
